import request from '@/front/shared/utils/request';

export const primaryKey = 'id';

export function remove(id, sessionId) {
    return request({
        url: `/sessions/${sessionId}/collaboration-invitations/${id}`,
        method: 'delete',
    });
}

export function show(id) {
    return get(id);
}

export function get(id, sessionId) {
    return request({
        url: `/sessions/${sessionId}/collaboration-invitations/${id}`,
        method: 'get',
    });
}

export function update(id, sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/collaboration-invitations/${id}`,
        method: 'put',
        data,
    });
}

export function store(sessionId, data) {
    return request({
        url: `/sessions/${sessionId}/collaboration-invitations`,
        method: 'post',
        data,
    });
}

export function save(data) {
    if (data.hasOwnProperty(primaryKey) && data[primaryKey] != null) {
        return update(data[primaryKey], data);
    }

    return store(data);
}
